import { useEffect, useState } from 'react';
//file import
import styles from '../../css/Analysis.module.css';

export default function AnalysisSelecting({
	state,
	setState,
	modal,
	setModal,
	checkedArray,
	setCheckedArray,
	setNullData,
	setAnalData,
	setAnalViewData,
	analysisData
}) {

	//데이터 받아오기
	const [checkedCodeArray, setCheckedCodeArray] = useState([]);

	// checkbox onChange function
	const inputHandler = (e, code) => {
		const value = e.target.value;
		const newArray = checkedArray.includes(value)? checkedArray.filter(menu => menu !== value) : [...checkedArray, value];
		const newCodeArray = checkedCodeArray.includes(code)? checkedCodeArray.filter(menu => menu !== code) : [...checkedCodeArray, code];
		
		setCheckedArray(newArray);
		setCheckedCodeArray(newCodeArray);
		setNullData(value)
	};

	const handleListOpen = () => {
		setState({...state, list:true, menu:false})
		setAnalData(checkedCodeArray);

		let checkList = [];
		for (let i = 0; i < checkedArray.length; i++) {
			// 각 요소에 접근하여 작업을 수행합니다.
			checkList.push({'name': checkedArray[i], 'code': checkedCodeArray[i]})
		}
		setAnalViewData(checkList);
	}

	return (
		<>
			<div className={`${styles.container} 
											${styles.businessContainer} 
											${styles.categoryOrigin}`}>
				<ul className={styles.category}>
					{
						analysisData.map((menu, code) => (
							<li key={code} onDoubleClick={() => setModal({ ...modal, modalSelect: true})}>
								<input type='checkbox'
									id={`analysis_${menu.code}`}
									name='select'
									value={menu.value}
									code={menu.code}
									onChange={(e) => inputHandler(e, menu.code)}
									checked={checkedArray.includes(menu.value)}
								/>
								<label htmlFor={`analysis_${menu.code}`}>
									<img src={menu.icon} alt='icon' />
									{menu.value}
								</label>
							</li>
						))
					}
				</ul>
				<button type='submit' onClick={handleListOpen}>확인</button>
			</div>
		</>
	)
}